import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";

const curriculumData = [
  {
    title: "IoT Foundations & Connected Technologies",
    description:
      "Understanding IoT & its evolution, How smart devices communicate, IoT components: sensors actuators microcontrollers, Applications in home automation healthcare agriculture and industry, Role of IoT in Industry 4.0",
  },
  {
    title: "Electronics Basics & Sensor Interfacing",
    description:
      "Introduction to electronic components (resistors capacitors diodes), Using sensors: temperature humidity motion gas light, Analog vs digital signals, Working with actuators (motors relays buzzers), Real-world sensor circuit building",
  },
  {
    title: "Microcontrollers & Embedded Systems",
    description:
      "Understanding microcontrollers (Arduino ESP32 ESP8266), Digital input/output operations, Timers interrupts & PWM, Writing embedded C/C++ programs, Building smart hardware prototypes",
  },
  {
    title: "IoT Communication Protocols & Networking",
    description:
      "Wi-Fi Bluetooth Zigbee LoRa RFID basics, MQTT HTTP & CoAP communication, Understanding IoT gateways, Data transfer between devices & servers, Choosing the right protocol for the right project",
  },
  {
    title: "Cloud Platforms & IoT Data Management",
    description:
      "Introduction to IoT cloud platforms (AWS IoT Azure IoT Google IoT Core), Sending data from devices to cloud, Storing analyzing & visualizing sensor data, MQTT brokers & dashboards, Real-time monitoring using cloud services",
  },
  {
    title: "Mobile App & Web Integration for IoT",
    description:
      "Connecting IoT devices with mobile apps, Blynk Adafruit IO Firebase integration, Creating dashboards for device control, Real-time notifications & alerts, Hands-on automation system development",
  },
  {
    title: "IoT Security & Data Protection",
    description:
      "Threats: device hijacking, data theft, network breach, Secure authentication & encryption, Best practices for device and network security, API security for IoT applications, Creating safe and reliable IoT networks",
  },
  {
    title: "Automation, AI & Smart Systems Introduction",
    description:
      "Introduction to smart automation workflows, Using AI/ML with IoT devices, Smart home automation concepts, Predictive maintenance & analytics, Real-world smart city applications",
  },
  {
    title: "Protocol Implementation & Hardware-to-Cloud Projects",
    description:
      "NodeMCU/ESP32 → Cloud communication, Complete sensor data logging system, Cloud automation rules, Dashboard creation & alert systems, IoT-to-app complete workflow implementation",
  },
  {
    title: "Capstone IoT Project & Career Preparation",
    description:
      "End-to-end IoT project (hardware + software + cloud), Documenting full workflow, PCB design introduction, GitHub project publishing, Interview prep for IoT Developer Embedded Engineer IoT Analyst roles",
  },
];

const ProgramCurriculum = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleSection = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="curriculum-container">
      <motion.h2
        className="curriculum-heading"
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Program Curriculum
      </motion.h2>
      <motion.p
        className="curriculum-subtext"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.6 }}
      >
        This curriculum is structured in a practical and progressive format so
        you can learn step-by-step from zero to advanced level — and build
        real-world applications.
      </motion.p>
      <div className="curriculum-list">
        {curriculumData.map((item, index) => (
          <motion.div
            key={index}
            className="curriculum-item"
            onClick={() => toggleSection(index)}
            whileHover={{ x: 10 }}
            transition={{ duration: 0.3 }}
          >
            <div className="title-row">
              <span className="curriculum-title">{item.title}</span>
              <motion.span
                animate={{ rotate: activeIndex === index ? 90 : 0 }}
                transition={{ duration: 0.3 }}
                className="arrow"
              >
                ➤
              </motion.span>
            </div>
            <AnimatePresence>
              {activeIndex === index && (
                <motion.p
                  className="curriculum-description"
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  {item.description}
                </motion.p>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ProgramCurriculum;
